var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"language"},[_c('img',{attrs:{"src":require(("@/assets/img/" + _vm.language + ".png")),"alt":"","width":"16px","height":"16px"}}),_c('span',[_vm._v(_vm._s(_vm.language))])])}
var staticRenderFns = []

export { render, staticRenderFns }